<template>
  <div class="needDealtWidthBox">
    <div class="content">
      <el-table
      :data="tableData"
      v-loading="tableLoading"
      :header-cell-style="{ fontWeight: 500, color: 'rgb(0,0,0,0.85)', background: '#fafafa' }"
      style="width: 100%">
        <el-table-column prop="name" label="代办名称" />
        <el-table-column prop="yeTypeName" label="代办分类" />
        <el-table-column label="流程图">
          <template slot-scope="{ row }">
            <el-link type="primary" @click="viewPic(row)">流程图</el-link>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="{ row }">
            <el-link type="primary" :underline="false" @click="viewDetile(row)" style="margin-right: 5px">详情</el-link>
            <el-link type="primary" :underline="false" @click="dealwithBtn(row, 1)" style="margin-right: 5px">审核</el-link>
            <el-link v-if="row.isReject && row.ywType !== 'Target_management_rectify' &&
              row.fromKey !== 'Target_management_rectify/recheck'"
              type="danger" :underline="false" @click="dealwithBtn(row, 2)" style="margin-right: 5px">驳回</el-link>
            <el-link v-if="row.isReject && row.ywType === 'Target_management_rectify'
              && row.fromKey === 'Target_management_rectify/recheck'" type="danger"
              :underline="false" @click="dealwithBtn(row, 2)" style="margin-right: 5px">不合格</el-link>
            <!-- <el-link v-if="row.isProxy" type="info" :underline="false" @click="dealwithBtn(row, 3)">转派</el-link> -->
            <el-link type="info" :underline="false" @click="dealwithBtn(row, 3)">转派</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 处理弹窗 -->
    <el-dialog
      title="待办处理"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <div class="diaContent">
        <el-form :modal="diaForm" label-position="top">
          <el-form-item label="处理内容" required>
            <el-input v-model="diaForm.comment" type="textarea" :rows="3" />
          </el-form-item>
          <!-- <el-form-item label="转派人" v-if="diaObj.isProxy && diaStatus === 3" required> -->
          <el-form-item label="转派人" required v-if="diaStatus === 3">
            <el-select v-model="diaForm.proxyUserId">
              <el-option v-for="item in userList" :key="item.id" :value="item.id" :label="item.nickname" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button v-if="diaStatus === 1" type="primary" @click="submitBtn(1)" size="small">通 过</el-button>
        <el-button v-if="diaStatus === 2" type="primary" @click="submitBtn(2)" size="small">驳 回</el-button>
        <el-button v-if="diaStatus === 3" type="primary" @click="submitBtn(3)" size="small">转 派</el-button>
      </span>
    </el-dialog>
    <!-- 流程图查看 -->
    <el-dialog title="查看流程图"
      :visible.sync="imgVisible"
      width="40%">
      <el-image :src="fileField" alt="" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="innerVisible = true">全屏查看</el-button>
        <el-button type="primary" size="small" @click="imgVisible = false">确 定</el-button>
      </span>
      <!-- 全屏查看的内层弹窗 -->
      <el-dialog
        width="30%"
        title=""
        fullscreen
        :visible.sync="innerVisible"
        append-to-body>
        <el-image :src="fileField" alt="" />
      </el-dialog>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog
      title="待办详情"
      :visible.sync="detailVisible"
      width="30%"
      top="5vh"
      :before-close="detailClose">
      <el-form :modal="drawerObj" label-width="110px">
        <el-form-item v-for="(item, key) in drawerObj" :key="key" :label="key + '：'">
          <span>{{ item }}</span>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 作业的弹窗 -->
		<component
		  :is="currentComponent"
			:customer_id="customer_id"
			@componentResult="componentResult"
			:dialogVisible="dialogVisible2"
			:message="message"
      :isWork="true"
			:userList="userList2"
		>
		</component>
  </div>
</template>

<script>
import { getNeedDealWithList, submitMyTask } from "@/api/workStation"
import { needDeal, ispass, reassignment } from "@/api/model"
import { getAlluser, getWorkDetail, getEmpBindUser } from "@/api/processManager"
import contrastData from './contrastData.json'
import axios from 'axios'
export default {
  name: 'needDealtWidth',
  components: {
    // 动态引入组件
    TemporaryElectricity(resolve) {
      require(["@/components/components/home/process/complexityTable/temporaryElectricity"], resolve)
    },
    PremiumFirePlayer(resolve) {
      require(["@/components/components/home/process/complexityTable/premiumFirePlayer"], resolve)
    },
    RestrictedSpace(resolve) {
      require(["@/components/components/home/process/complexityTable/restrictedSpace"], resolve)
    },
    BlindBoard(resolve) {
      require(["@/components/components/home/process/complexityTable/blindBoard"], resolve)
    },
    HighPlaceWork(resolve) {
      require(["@/components/components/home/process/complexityTable/highPlaceWork"], resolve)
    },
    HoistingWork(resolve) {
      require(["@/components/components/home/process/complexityTable/hoistingWork"], resolve)
    },
    BreakRoad(resolve) {
      require(["@/components/components/home/process/complexityTable/breakRoad"], resolve)
    },
    // Groundbreaking(resolve) {
    //   require([""], resolve)
    // }
  },
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      dialogVisible2: false,
      diaObj: {},
      diaForm: {},
      fileField: null,
      imgVisible: false,
      innerVisible: false,
      diaStatus: 1,
      userList: [],
      tableLoading: false,
      drawerObj: {}, // 详情弹窗的数据对象
      detailVisible: false,
      /// 动态引入打印预览弹窗的数据
      currentComponent: "",
      customer_id:'',
      message: {},
      userList2: []
    }
  },
  created() {
    this.getData()
    this.getUser()
    // 获取绑定了用户的员工
    getEmpBindUser().then(res => {
      this.userList2 = res.body.data
    })
  },
  methods: {
    // 获取人员列表
    getUser() {
      getAlluser().then(res => {
        this.userList = res.body.data
      })
    },
    getData() {
      this.tableLoading = true
      needDeal().then(res => {
        if(res.code === '100') {
          this.tableData = res.body.data
          this.tableLoading = false
        }else if(res.code === '400') {
          this.$message.info(res.body.error_msg)
          this.tableData = []
          this.tableLoading = false
        }
      })
    },
    viewPic(row) {
      this.tableLoading = true
      let obj = new FormData()
      obj.append('processDefinitionId', row.processDefinitionId)
      obj.append('processInstanceId', row.processInstanceId)
      axios({
        method: 'post',
        url: "/v1/processinstance/processPhoto",
        responseType: 'arraybuffer',
        data: obj
      }).then(res => {
        this.fileField = 'data:image/png;base64,' + btoa(
          new Uint8Array(res.data)
            .reduce((data, byte) => data + String.fromCharCode(byte), ''))
        this.imgVisible = true
        this.tableLoading = false
      })
    },
    // 查看详情
    viewDetile(row) {
      if(row.ywType === 'break_ground_work' ||  row.ywType === 'short_circuit_work'
       || row.ywType === 'hoisting_work' || row.ywType === 'high_place_work' || row.ywType === 'blind_plate_work'
       || row.ywType === 'confined_space_work' || row.ywType === 'fire_work' || row.ywType === 'Job_power_utilization')
      {
        // 查看作业的详情
      // 动态引入组件的事件
        getWorkDetail({ id: row.businessKey }).then(res => {
          let obj = res.body.data
          if (obj.certificateTypeId === 3) {
            this.currentComponent = 'TemporaryElectricity' // 临时用电安全
          } else if (obj.certificateTypeId === 4 || obj.certificateTypeId === 5 || obj.certificateTypeId === 6) {
            this.currentComponent = 'PremiumFirePlayer' // 动火
          } else if (obj.certificateTypeId === 7) {
            this.currentComponent = 'RestrictedSpace' // 受限空间
          } else if (obj.certificateTypeId === 8) {
            this.currentComponent = 'BlindBoard' // 盲板抽堵
          } else if (obj.certificateTypeId === 9) {
            this.currentComponent = 'HighPlaceWork' // 高出作业
          } else if (obj.certificateTypeId === 10) {
            this.currentComponent = 'HoistingWork' // 吊装安全作业
          } else if (obj.certificateTypeId === 11) {
            this.currentComponent = 'BreakRoad' // 断路安全作业人
          } else if (obj.certificateTypeId === 12) {
            this.currentComponent = 'Groundbreaking' // 动土
          }
          obj.businessJson = JSON.parse(obj.businessJson)
          obj.reviewContentJson = JSON.parse(obj.reviewContentJson)
          obj.reviewLogJson = JSON.parse(obj.reviewLogJson)
          this.message = obj
          // console.log(this.message)
          this.customer_id = row.businessKey;
          this.dialogVisible2 = true
        })
        return
      }
      let obj = {}
      let drawerObj = {}
      try {
        obj = contrastData[row.ywType]
        for(let i in obj) {
          for(let j in row.businessObj) {
            if(i === j) {
              drawerObj[obj[i]] = row.businessObj[j]
            }
          }
        }
      } catch(error) {
        drawerObj = {}
      }
      this.drawerObj = { ...drawerObj }
      this.detailVisible = true
    },
    // 关闭详情
    detailClose() {
      this.detailVisible = false
    },


    componentResult(status) {
      console.log(status)
      this.dialogVisible2 = status
    },

    // 操作的事件
    dealwithBtn(row, status) {
      this.diaObj = { ...row }
      this.dialogVisible = true
      this.diaStatus = status
    },
    handleClose() {
      this.dialogVisible = false
      this.$set(this.diaForm, 'comment', '')
    },
    async submitBtn(status) {
      let obj = { ...this.diaForm, taskId: this.diaObj.taskId }
      // 通过
      if(status === 1) {
        if(this.diaObj.isReject) {
          obj.type = 1
        }
        await ispass(obj).then(res => {
          this.$message.success('处理成功')
        })
      }
      // 驳回
      else if(status === 2) {
        obj.type = 2
        await ispass(obj).then(res => {
          this.$message.success('处理成功')
        })
      }
      // 转派
      else if(status === 3) {
        await reassignment(obj).then(res => {
          this.$message.success('处理成功')
        })
      }
      this.dialogVisible = false
      this.getData()
    }
  }
}
</script>

<style scoped>
.content {
  height: calc(100vh - 120px);
  overflow: scroll;
}
/deep/ .el-form-item {
  margin-bottom: 5px;
  border-bottom: 1px solid #f3f3f3
}
</style>